/** Stored values remain stable; every review uses the same readable labels. */
export const BUSINESS_DURATIONS = [
  { value: 'UNDER_1', label: 'Under 1 year' },
  { value: '1_2', label: '1–2 years' },
  { value: '3_6', label: '3–6 years' },
  { value: 'OVER_6', label: 'Over 6 years' },
];

export function formatBusinessDuration(value: string): string {
  return BUSINESS_DURATIONS.find((duration) => duration.value === value)?.label ?? value;
}
